import './CombinedStatusTrend.css';

import { generateClassName } from '../../../b2b-common/helpers';
import { StatusTrendIcon } from '../helper';
import React from 'react';

const CombinedStatusTrend = ({ status, trend,
    showStatus = true, showTrend = true,
    className = null, locale = null }) => {
    return (
        <div className={generateClassName('combined-status-and-trend', '', className)}>
            <StatusTrendIcon status={status} trend={trend} showStatus={showStatus} showTrend={showTrend} locale={locale} />
        </div>
    )
}

export default CombinedStatusTrend;